@if (isOpen()) {
  <div class="project-nav__backdrop" (click)="close()"></div>
}

<nav class="project-nav" [class.project-nav--open]="isOpen()">
  <div class="project-nav__container">
    @for (section of sections; track section.stepId) {
      <app-nav-item
        [class.is-active]="isActive(section.stepId)"
        [class.is-locked]="isLocked(section.stepId)"
        (click)="openStep(section.stepId)"
        a11yKeyboardClickable
      >{{ section.label }}</app-nav-item>

      @if (section.stepId === projectSteps.QUICKSCAN && isActive(projectSteps.QUICKSCAN)) {
        @for (category of visibleCategories(); track category.id; let index = $index) {
          <app-nav-item
            class="project-nav__sub"
            [class.is-active]="category.id === activeAnalysisCategoryId() || (index === 0 && !activeAnalysisCategoryId())"
            (click)="openAnalysisCategory(category)"
            a11yKeyboardClickable
          >{{ index + 1 }}. {{ category.name }}</app-nav-item>
        }
      }
    }

    <hr class="project-nav__divider" />

    <app-nav-item
      [class.is-active]="isRisksAndOpportunitiesActive()"
      [class.is-locked]="isRisksAndOpportunitiesLocked()"
      (click)="openRisksAndOpportunities()"
      a11yKeyboardClickable
    >{{ risksAndOpportunitiesLabel }}</app-nav-item>

    @if (isRisksAndOpportunitiesActive()) {
      @for (section of risksAndOpportunitiesSections; track section.stepId) {
        <app-nav-item
          class="project-nav__sub"
          [class.is-active]="isActive(section.stepId)"
          [class.is-locked]="isLocked(section.stepId)"
          (click)="openStep(section.stepId)"
          a11yKeyboardClickable
        >{{ section.label }}</app-nav-item>
      }
    }
  </div>
</nav>
